import { Box } from "@mui/material"
import useStyles from "./styles"
import BaseAppBar from "@/components/base/app-bar"
import { EditContainerProps } from "@/types/page"
import { DrawerBloc } from "@/components/widget/drawer-bloc"

const EditServicesContainer = ({ children, onClose, open }: EditContainerProps) => {
    const { classes } = useStyles()

    return (
        <DrawerBloc
            disableScrollLock
            data-testid="close-services"
            hideBackdrop
            anchor={"right"}
            open={open}
            onClose={onClose}
            transitionDuration={600}
            disableEscapeKeyDown
            classPaper={classes.container}
            className={classes.drawer}
        >
            <BaseAppBar />
            <Box className="children-wrapper">{children}</Box>
        </DrawerBloc>
    )
}

export default EditServicesContainer
